<template>
    <v-flex>
        <div class="elevation-3">
            <div class="noTableHeader">
                <v-dialog persistent v-model="modal" max-width="1000px">
                    <v-btn slot="activator" color="#f8ac4a" dark class="mb-2">
                        <v-icon class="buttonIconText" color="white">playlist_add</v-icon> Nova {{name}}</v-btn>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                        <div v-if="isLoading" style="width: 100%; text-align: center;">
                                            <v-progress-circular indeterminate color="amber"/>
                                        </div>
                                    <v-layout v-if="!isLoading" wrap>
                                        <v-flex xs12 sm12 md12>
                                            <v-form ref="form" v-on:submit.prevent>
                                                <v-layout row wrap align-center>
                                                    <v-flex xs12 sm12 md12>
                                                            <v-layout row wrap align-center>
                                                                <v-flex xs6 sm6 md6>
                                                                    <label class="label-modal">Pergunta</label>
                                                                    <v-text-field v-if="pergunta.id_tipo != 5" @click:prepend="pergunta.required = !pergunta.required" :prepend-icon="pergunta.required ? 'check_box' : 'check_box_outline_blank'" color="#f8ac4a" :rules="defaultRules" v-model="pergunta.nome"></v-text-field>
                                                                    <v-text-field v-else color="#f8ac4a" :rules="defaultRules" v-model="pergunta.nome"></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 sm3 md3>
                                                                    <label class="label-modal">Dimensão</label>
                                                                    <v-autocomplete color="#f8ac4a" :items="getDimensoes" v-model="pergunta.id_dimensao" item-text="nome" item-value="id_dimensao" :rules="defaultRules"></v-autocomplete>
                                                                </v-flex>
                                                                <v-flex v-bind:class="[(pergunta.id_tipo == 5 || pergunta.id_tipo == 1 || pergunta.id_tipo == 2) && editedIndex == -1 ? 'xs2 sm2 md2' : 'xs3 sm3 md3']">
                                                                    <label class="label-modal">Tipo pergunta</label>
                                                                    <v-autocomplete color="#f8ac4a" :items="getTipos" :disabled="editedIndex != -1" v-model="pergunta.id_tipo" item-text="nome" item-value="id_tipo" @change="changeTipo" :rules="defaultRules"></v-autocomplete>
                                                                </v-flex>
                                                                <v-flex xs1 sm1 md1 class="pActions">
                                                                    <v-btn v-if="(pergunta.id_tipo == 5 || pergunta.id_tipo == 1 || pergunta.id_tipo == 2) && editedIndex == -1" @click="addChildren" fab dark small color="#f8ac4a">
                                                                        <v-icon dark>add</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                            </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 sm12 md12 v-for="(child, i) in pergunta.children" :key="i">
                                                        <v-layout row wrap align-center>
                                                            <v-flex xs12 sm12 md12>
                                                                <v-layout row wrap align-center class="parent">
                                                                    <v-flex class="child-1" v-bind:class="[(pergunta.id_tipo == 5 || pergunta.id_tipo == 1 || pergunta.id_tipo == 2 || child.expansivel) ? 'xs5 sm5 md5' : 'xs6 sm6 md6']">
                                                                        <label class="label-modal">Opção</label>
                                                                        <v-text-field v-if="pergunta.id_tipo == 5" @click:prepend="child.required = !child.required" :prepend-icon="child.required ? 'check_box' : 'check_box_outline_blank'" color="#f8ac4a" :rules="defaultRules" v-model="child.nome"></v-text-field>
                                                                        <v-text-field v-else color="#f8ac4a" :rules="defaultRules" v-model="child.nome"></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex v-if="pergunta.id_tipo == 5 || child.expansivel || (editedIndex!=-1 && child.id_tipo > 0)" xs2 sm2 md2>
                                                                        <label class="label-modal">Tipo pergunta</label>
                                                                        <v-autocomplete color="#f8ac4a" :disabled="editedIndex != -1" @change="changeTipoChild(child)" :items="getTipos.filter((el)=>{ return el.id_tipo != 5 })" v-model="child.id_tipo" item-text="nome" item-value="id_tipo"></v-autocomplete>
                                                                    </v-flex>
                                                                    <v-flex v-if="pergunta.id_tipo == 1 || pergunta.id_tipo == 2" xs2 sm2 md2>
                                                                        <label class="label-modal">Expansível</label>
                                                                        <v-autocomplete color="#f8ac4a" :disabled="editedIndex != -1" :items="isExpansivel" v-model="child.expansivel" item-text="nome" item-value="expansivel"></v-autocomplete>
                                                                    </v-flex>
                                                                    <v-flex v-bind:class="[((pergunta.id_tipo == 5 || pergunta.id_tipo == 1 || pergunta.id_tipo == 2) && (child.id_tipo == 1 || child.id_tipo == 2 || child.expansivel) && editedIndex == -1) ? 'xs2 sm2 md2' : 'xs1 sm1 md1']" class="pActions">
                                                                        <v-btn v-if="(pergunta.id_tipo == 5 || pergunta.id_tipo == 1 || pergunta.id_tipo == 2) && (child.id_tipo == 1 || child.id_tipo == 2 || child.expansivel) && editedIndex == -1" @click="addChild(child)" fab dark small color="#f8ac4a">
                                                                            <v-icon dark>add</v-icon>
                                                                        </v-btn>
                                                                        <v-btn @click="deleteChildren(child)" fab dark small color="#ff5252">
                                                                            <v-icon dark>delete</v-icon>
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-flex>

                                                            <v-flex xs12 sm12 md12 v-for="(c, j) in child.children" :key="j">
                                                                <v-flex xs12 sm12 md12>
                                                                    <v-layout row wrap align-center>
                                                                        <v-flex class="child-2"  v-bind:class="[(child.id_tipo == 5 || child.id_tipo == 1 || child.id_tipo == 2) ? 'xs5 sm5 md5' : 'xs6 sm6 md6']">
                                                                            <label class="label-modal">Opção</label>
                                                                            <v-text-field color="#f8ac4a" :rules="defaultRules" v-model="c.nome"></v-text-field>
                                                                        </v-flex>
                                                                        <v-flex  xs2 sm2 md2 v-if="c.expansivel || (editedIndex!=-1 && c.id_tipo > 0)">
                                                                            <label class="label-modal">Tipo pergunta</label>
                                                                            <v-autocomplete color="#f8ac4a" :items="getTipos.filter((el)=>{ return el.id_tipo != 5})" :disabled="editedIndex != -1" v-model="c.id_tipo" item-text="nome" item-value="id_tipo"></v-autocomplete>
                                                                        </v-flex>
                                                                        <v-flex v-if="child.id_tipo == 1 || child.id_tipo == 2" xs2 sm2 md2>
                                                                            <label class="label-modal">Expansível</label>
                                                                            <v-autocomplete color="#f8ac4a" :disabled="editedIndex != -1" :items="isExpansivel" v-model="c.expansivel" item-text="nome" item-value="expansivel"></v-autocomplete>
                                                                        </v-flex>
                                                                        <v-flex v-bind:class="[((c.expansivel) && editedIndex == -1) ? 'xs2 sm2 md2' : 'xs1 sm1 md1']" class="pActions">
                                                                            <v-btn v-if="(c.expansivel) && editedIndex == -1" @click="addChildChild(child, c)" fab dark small color="#f8ac4a">
                                                                                <v-icon dark>add</v-icon>
                                                                            </v-btn>
                                                                            <v-btn @click="deleteChild(child, c)" fab dark small color="#ff5252">
                                                                                <v-icon dark>delete</v-icon>
                                                                            </v-btn>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>

                                                                <v-flex xs12 sm12 md12 v-for="(n, k) in c.children" :key="k">
                                                                    <v-layout row wrap align-center>
                                                                        <v-flex class="child-3" v-bind:class="[(c.id_tipo == 1 || c.id_tipo == 2) ? 'xs5 sm5 md5' : 'xs6 sm6 md6']">
                                                                            <label class="label-modal">Opção</label>
                                                                            <v-text-field color="#f8ac4a" :rules="defaultRules" v-model="n.nome"></v-text-field>
                                                                        </v-flex>
                                                                        <v-flex xs1 sm1 md1 class="pActions">
                                                                            <v-btn @click="deleteChildChild(c, n)" fab dark small color="#ff5252">
                                                                                <v-icon dark>delete</v-icon>
                                                                            </v-btn>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                            </v-form>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="#f8ac4a" flat @click.native="close">Cancelar</v-btn>
                                <v-btn color="#f8ac4a" :disabled="isLoading" flat @click.native="save">Guardar</v-btn>
                            </v-card-actions>
                    </v-card>
                </v-dialog>
    
                <v-text-field color="#f8ac4a" class="searchTable" v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
            </div>
    
            <v-dialog persistent v-model="deleteM" max-width="390">
                <v-card>
                    <v-card-title class="headline" style="margin-left: 0px !important;">Apagar {{name}}</v-card-title>
                    <v-card-text>De certeza que quer apagar esta {{name}}?</v-card-text>
                    <v-card-actions style="margin-top: 0px !important;">
                        <v-spacer></v-spacer>
                        <v-btn color="#f8ac4a" flat="flat" @click.native="close">Cancelar</v-btn>
                        <v-btn color="#f8ac4a" flat="flat" @click.native="save">Apagar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    
            <v-data-table :headers="headers" :items="DATA" :search="search" :loading="loading" item-key="id" :disable-initial-sort="true" :rows-per-page-items='[10,25,50,{"text":"Todos","value":-1}]' rows-per-page-text="Itens por página:">
                <template slot="items" slot-scope="props">
                        <td @click="editItem(props.item, true)" style="width: 15%;" class="textLeft">{{ props.item.id_pergunta }}</td>
                        <td @click="editItem(props.item, true)" style="width: 60%" class="textLeft">{{ props.item.nome }}</td>
                        <td class=" px-0 textTable textCenter">
                        	<v-btn icon class="mx-0" @click="editItem(props.item, true)">
                                <v-icon color="light-green darken-1">edit</v-icon>
                            </v-btn>
                            <v-btn icon class="mx-0" @click="editItem(props.item, false)">
                                <v-icon color="red lighten-1">delete</v-icon>
                            </v-btn>
                        </td>
</template>

<template class="alertTable" slot="no-data">
    <!-- <v-alert :value="true" icon="warning">
                    De momento não há nada a apresentar! :(
                </v-alert> -->
                <v-progress-circular
                style="margin-left: 50% !important;"
                indeterminate
                color="#f8ac4a"
                ></v-progress-circular>
</template>
            </v-data-table>
            
        </div>
    </v-flex>
</template>

<script>
import { instance as axios } from "../../store/axios";
import { mapState, mapGetters, mapActions } from "vuex";
    const cName = {
        upper: "Pergunta",
        lower: "a pergunta!"
    };
    
    export default {
        data: () => ({
            isLoading: false,
            table: 'perguntas',
            name: 'pergunta',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            isExpansivel: [{expansivel: 0, nome: 'Não expansível'}, {expansivel: 1, nome: 'Expansível'}],
            pergunta: {
                nome: '',
                id_dimensao: 0,
                id_tipo: 0,
                required: 1,
                children: [],
                expansivel: 0
            },
            headers: [
            {
                text: "#",
                align: "left",
                sortable: true,
                value: "id_pergunta"
            },
            {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            },
            {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }
            ],
            DATA: [],
            editedIndex: -1,
            defaultItem: {
                nome: '',
                id_dimensao: 0,
                id_tipo: 0,
                required: 1,
                children: [],
                expansivel: 0
            },
            messages: {
                add: {
                    success: cName.upper + " criada com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterada com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminada com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null
        }),
    
        computed: {
            ...mapGetters({
                getAll: 'perguntas/getAll',
                getDimensoes: 'dimensoes/getAll',
                getDimensaoById: 'dimensoes/getById',
                getTipos: 'tipos/getAll'
            }),
            formTitle() {
                return this.editedIndex === -1 ? "Nova "+this.name : "Editar "+this.name;
            }
        },
    
        watch: {
            modal(val) {
                val || this.close()
            },
            deleteM(val) {
                val || this.close()
            },
            getAll(val) {
                this.initialize()
            }
        },
    
        created() {
            this.defaultRules = [v => !!v || this.$requiredField + ''];
            this.initialize();
       },
        mounted() {
            
        },
        methods: {
            deleteChildChild(child, c) {
                if(this.editedIndex == -1) child.children.splice(child.children.findIndex((e)=>{ return e.id_pergunta == c.id_pergunta }), 1);
                else {
                    this.$store
                    .dispatch(this.table+"/delete", {id: c.id_pergunta})
                    .then((res) => {
                        if(res) { this.toast('success', this.messages.delete.success); child.children.splice(child.children.findIndex((e)=>{ return e.id_pergunta == c.id_pergunta }), 1); }
                        else this.toast('error', this.messages.delete.error);
                    });
                }
            },
            deleteChild(parent, child){
                if(this.editedIndex == -1) this.pergunta.children.find((el)=>{ return el.id_pergunta == parent.id_pergunta }).children.splice(this.pergunta.children.find((el)=>{ return el.id_pergunta == parent.id_pergunta }).children.findIndex((e)=>{ return e.id_pergunta == child.id_pergunta }), 1);
                else {
                    this.$store
                    .dispatch(this.table+"/delete", {id: child.id_pergunta})
                    .then((res) => {
                        if(res) { this.toast('success', this.messages.delete.success); this.pergunta.children.find((el)=>{ return el.id_pergunta == parent.id_pergunta }).children.splice(this.pergunta.children.find((el)=>{ return el.id_pergunta == parent.id_pergunta }).children.findIndex((e)=>{ return e.id_pergunta == child.id_pergunta }), 1); }
                        else this.toast('error', this.messages.delete.error);
                    });
                }
            },
            addChild(child) {
                this.pergunta.children.find((el)=>{ return el.id_pergunta == child.id_pergunta }).children.push({id_pergunta: child.children.length, expansivel: 0, nome: '', children: [], id_tipo: 0 });
            },
            addChildChild(child, c) {
                this.pergunta.children.find((el)=>{ return el.id_pergunta == child.id_pergunta }).children.find((e)=>{ return e.id_pergunta == c.id_pergunta }).children.push({id_pergunta: c.children.length, nome: '', id_tipo: 0, expansivel: 0, });
            },
            deleteChildren(child){
                if(this.editedIndex == -1) this.pergunta.children.splice(this.pergunta.children.findIndex((el)=>{ return el.id_pergunta == child.id_pergunta }), 1);
                else {
                    this.$store
                    .dispatch(this.table+"/delete", {id: child.id_pergunta})
                    .then((res) => {
                        if(res) { this.toast('success', this.messages.delete.success); this.pergunta.children.splice(this.pergunta.children.findIndex((el)=>{ return el.id_pergunta == child.id_pergunta }), 1); }
                        else this.toast('error', this.messages.delete.error);
                    });
                }
            },
            addChildren() {
                //if(!this.$refs.form.validate()) return;

                this.pergunta.children.push({id_pergunta: this.pergunta.children.length, nome: '', id_tipo: 0, expansivel: 0, children: [], required: this.pergunta.id_tipo == 5 ? 1 : 0 });
            },
            changeTipo() {
                if(this.pergunta.id_tipo == 3 || this.pergunta.id_tipo == 8 || this.pergunta.id_tipo == 4 || this.pergunta.id_tipo == 6 || this.pergunta.id_tipo == 7) this.pergunta.children = [];
            },
            changeTipoChild(child){
                if(child.id_tipo == 3 || child.id_tipo == 8 || child.id_tipo == 4 || child.id_tipo == 6 || child.id_tipo == 7) child.children = [];
            },
            toast(type, message) {
                if (type == "success") {
                    return iziToast.show({
                        title: "SUCESSO",
                        color: "green",
                        timeout: this.$toastTimeout,
                        message: message,
                        position: this.$toastPosition
                    });
                } else {
                    return iziToast.show({
                        title: "AVISO",
                        color: "red",
                        timeout: this.$toastTimeout,
                        message: message,
                        position: this.$toastPosition
                    });
                }
            },

            initialize() {
                this.loading = true;
                this.DATA = this.getAll;
                this.loading = false;
            },
    
            editItem(item, dialog) {
                
                if (dialog) {
                    this.isLoading = true;
                    this.modal = true;
                    axios.get("/pergunta/"+item.id_pergunta).then((res) => {
                        this.editedIndex = this.DATA.indexOf(item);
                        this.pergunta = {...res.data.data[0]};
                        this.isLoading = false;
                    });
                }
                else {
                    this.editedIndex = this.DATA.indexOf(item);
                    this.pergunta = {...item};
                    this.deleteM = true;
                }
            },
    
            delete() {
                if(!this.pergunta.id_pergunta) return;

                this.$store
                    .dispatch(this.table+"/delete", {id: this.pergunta.id_pergunta})
                    .then((res) => {
                        if(res) { this.toast('success', this.messages.delete.success); this.initialize(); }
                        else this.toast('error', this.messages.delete.error);
                            
                        this.deleteM = false;
                    });
            },
    
            close() {
                this.modal = this.deleteM = this.isLoading = false;
                setTimeout(() => {
                    delete this.pergunta.children;
                    this.editedIndex = -1;
                    
                    setTimeout(() => {
                        this.$refs.form.reset();
                        this.pergunta = Object.assign({}, this.defaultItem);
                    }, 50);
                }, 110);
            },
    
            async save() {
                if(this.deleteM) {this.delete(); return;}

                if(!this.$refs.form.validate()) return;
                
                var status = await this.checkForm(this.pergunta);

                if(!status) {this.toast('error', 'O formulario não está preenchido corretamente!'); return;}

                if(this.editedIndex == -1) {
                    this.pergunta.required = this.pergunta.required ? 1 : 0; 
                    this.$store
                    .dispatch(this.table+"/insert", {pergunta: this.pergunta})
                    .then((res) => {
                        
                        if(res) { this.toast('success', this.messages.add.success); this.initialize(); }
                        else this.toast('error', this.messages.add.error);
                            
                        this.modal = false; 
                    });
                }
                else {
                    var perguntas = await this.prepareArray(this.pergunta);
                    
                    this.$store
                    .dispatch(this.table+"/update", {perguntas: perguntas})
                    .then((res) => {
                        if(res) { this.toast('success', this.messages.update.success); this.initialize(); }
                        else this.toast('error', this.messages.update.error);
                            
                        this.modal = false;
                    });
                }
            },

            checkForm(pergunta) {
                var completed = [];
                var i = 0;
                if(pergunta.id_tipo == 5) {
                    if(!pergunta.hasOwnProperty('children') || (pergunta.hasOwnProperty('children') && pergunta.children.length == 0)) completed.push(false);
                    else {
                        for(var c of pergunta.children) {
                            i++;
                            if(c.id_tipo == 1 || c.id_tipo == 2) {
                                if(c.children.length == 0) completed.push(false);
                                else {
                                    for(var n of c.children) {
                                        if(n.expansivel) {
                                            if(n.id_tipo < 5 && n.children.length == 0) completed.push(false);
                                            else completed.push(true)
                                        }
                                        else completed.push(true)
                                    }
                                }
                            }
                            else completed.push(true)

                            if(i==pergunta.children.length) return completed.findIndex((el)=>{ return el == false }) == -1 ? true : false
                        }
                    }
                }
                else if(pergunta.id_tipo == 1 || pergunta.id_tipo == 2) {
                    if(!pergunta.hasOwnProperty('children') || (pergunta.hasOwnProperty('children') && pergunta.children.length == 0)) completed.push(false);
                    else {
                        for(var c of pergunta.children) {
                            i++;
                            if(c.expansivel) {
                                if(c.children.length == 0) completed.push(false);
                                else {
                                    for(var n of c.children) {
                                        if(n.expansivel) {
                                            if(n.id_tipo < 5 && n.children.length == 0) completed.push(false);
                                            else completed.push(true)
                                        }
                                        else completed.push(true)
                                    }
                                }
                            }
                            else completed.push(true)

                            if(i==pergunta.children.length) return completed.findIndex((el)=>{ return el == false }) == -1 ? true : false
                        }
                    }
                }
                else return true

                
            },

            prepareArray(pergunta) {
                var aux = [];

                if(pergunta.id_tipo == 5) {
                    aux.push({ id: pergunta.id_pergunta, nome: pergunta.nome, required: pergunta.required ? 1 : 0, expansivel: pergunta.expansivel, id_dimensao: pergunta.id_dimensao });
                    for(var c of pergunta.children) {
                            aux.push({ id: c.id_pergunta, nome: c.nome, required: c.required ? 1 : 0, expansivel: c.expansivel, id_dimensao: c.id_dimensao });
                            if(c.children.length > 0) {
                                for(var n of c.children) {
                                    aux.push({ id: n.id_pergunta, nome: n.nome, required: n.required ? 1 : 0, expansivel: n.expansivel, id_dimensao: n.id_dimensao });
                                    if(n.expansivel) {
                                        for(var nn of n.children) {
                                            aux.push({ id: nn.id_pergunta, nome: nn.nome, required: nn.required ? 1 : 0, expansivel: nn.expansivel, id_dimensao: nn.id_dimensao });
                                        }
                                    }
                                }
                            }
                        }
                }
                else {
                    if(pergunta.id_tipo == 1 || pergunta.id_tipo == 2) {
                        aux.push({ id: pergunta.id_pergunta, nome: pergunta.nome, required: pergunta.required ? 1 : 0, expansivel: pergunta.expansivel, id_dimensao: pergunta.id_dimensao });
                        for(var c of pergunta.children) {
                            aux.push({ id: c.id_pergunta, nome: c.nome, required: c.required ? 1 : 0, expansivel: c.expansivel, id_dimensao: c.id_dimensao });
                            if(c.children.length > 0) {
                                for(var n of c.children) {
                                    aux.push({ id: n.id_pergunta, nome: n.nome, required: n.required ? 1 : 0, expansivel: n.expansivel, id_dimensao: n.id_dimensao });
                                    if(n.expansivel) {
                                        for(var nn of n.children) {
                                            aux.push({ id: nn.id_pergunta, nome: nn.nome, required: nn.required ? 1 : 0, expansivel: nn.expansivel, id_dimensao: nn.id_dimensao });
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else aux.push({ id: pergunta.id_pergunta, nome: pergunta.nome, required: pergunta.required ? 1 : 0, expansivel: pergunta.expansivel, id_dimensao: pergunta.id_dimensao });
                }

                return aux;
            }
        }
    }
</script>
<style scoped>
    .tipoPergunta {
        min-height: 100px !important;
        background-color: #f8ac4a !important;
        width: 100% !important;
        margin: 10px !important;
        cursor: pointer !important;
    }

    .pActions {
        display: flex !important;
        justify-content: flex-end !important;
    }

    .parent {
        background-color: #f5f5f5 !important;
    }
    
    .child-1 {
        margin-left: 30px !important;
    }

    .child-2 {
        margin-left: 60px !important;
    }

    .child-3 {
        margin-left: 90px !important;
        background-color: #f5f5f5 !important;
    }
</style>




// WEBPACK FOOTER //
// src/components/tables/Table_Perguntas.vue